export default function toTitle(string) {
  return string.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
}
